export default "__VITE_ASSET__CWA6OSRP__"